module.exports = __webpack_public_path__ + "static/media/greenDot.6ea36c48.svg";